/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";

let vm = new Vue();
let vuex = store.state;
export default {
    //类型
    type: 'scatter',
    //类别
    class: 'chart',
    //组件名称
    name: '散点图',
    //排序
    sort: 4,
    //是否在多维分析展示
    viewType:true,
    //图标
    iconImg: '/img/scatter.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 2,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 2,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
      // 子集展示的配置项
    chilCharts: [
        {
            name: '散点图',
            ordImg: '/img/scatter.png',
            bigImg: '/img/scatter.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                // stack: ''
            },
        },
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
     //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'top',
                //字体
                //字体
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                 //间隔
                marInterval:10,
                orient:'horizontal'
            },
            //轴线配置
            axios: {
                //主轴
                spind: {
                    show: true,
                    startVal: 0,
                    angle: 0,
                    color:'',
                },
                //次轴
                bout: {
                    show: true,
                    startVal: 0,
                    angle: 0,
                    //字体
                    font: {
                        show:true,
                        color: vuex.dpType === 1 ? '#fff' : '#333',
                        size: 12,
                    },
                },
                //X轴
                xAxios: {
                    show: true,
                    type:'value',
                    boundaryGap:true,
                    axisLine:{
                        show:true,
                        lineStyle:{
                            color: vuex.dpType === 1 ? '#fff' : '#333',
                            width: 1 ,
                            type: 'solid' ,
                        }
                    },
                    axisTick: {
                        show: true,
                        inside: false,
                    },
                    axisLabel: {
                        show: true,
                        fontSize: 12 ,
                        color: vuex.dpType === 1 ? '#fff' : '#333',
                        rotate: 0 ,
                    },
                    splitLine: {
                        show:true,
                        lineStyle: {
                            color: vuex.dpType === 1 ? ['#fff'] : ['#333'],
                            width: 1,
                            type:'solid'
                        }
                    },
                },
                //Y轴
                yAxios:{
                    yAxios: [{
                        show: true,
                        type:'value',
                        axisLine:{
                            show:true,
                            lineStyle:{
                                color: vuex.dpType === 1 ? '#fff' : '#333',
                                width: 1 ,
                                type: 'solid' ,
                            }
                        },
                        axisTick: {
                            show: true,
                            inside: false,
                        },
                        axisLabel: {
                            show: true,
                            fontSize: 12 ,
                            color: vuex.dpType === 1 ? '#fff' : '#333',
                            rotate: 0 ,
                        },
                        splitLine: {
                            show:true,
                            lineStyle: {
                                color: vuex.dpType === 1 ? ['#fff'] : ['#333'],
                                width: 1,
                                type:'solid'
                            }
                        },
                        min: 0,
                        startVal: 0,
                        angle: 0,
                    }],
                },
                font:{
                    color:vuex.dpType === 1 ? '#fff' : '#333',
                    size:12,
                    angle:0
                },
                //轴线颜色
                color: vuex.dpType === 1 ? '#fff' : '#333',

            },
            scatter:{
                show:false,
                symbol:'circle',
                symbolSize:'10',
                color:'',
                large:false
            }
        }
    },
    //右侧图表配置组件列表
    configModule: [
        {
            name: '图例配置',
            component: () => import('../../comConfig/comLegend/comLegend.vue')
        },
        {
            name: 'X轴配置',
            component: () => import('../../comConfig/axios/axios.vue')
        },
        {
            name: 'Y轴配置',
            component: () => import('../../comConfig/yAxios/yAxios.vue')
        },{
            name: '散点图配置',
            component: () => import('./config/scatter_config.vue')
        },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量1', '度量2']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    renderBefore(chart, nowChart,dom) {
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
        nowChart.comConfig.gridType = 0;
      
    },

    //渲染
    rendering(chart, nowChart, dom) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));
        //数据
        let dataVal = dataAll.dt;
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });
        //
        let legendList = [];
        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }

        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                filedNmae: i.filed,
                aliasNmae: i.alias,
                config: configDL,
            };
            node.value = dataVal.map((item) => {
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;

                    return {
                        value: item[i.alias],   
                        itemStyle: {
                            color: configDL.params.color
                        }
                    } || 0
                } else {
                    return item[i.alias] || 0
                }
            });
            dlVal.push(node);
            legendList.push(i.alias);
        });
        
        //获取维度数据
        let wdVal = [];
        if(wd[0]){
            wdVal = dataVal.map((item) => {
                return item[wd[0].alias];
            });
        }
        // 处理数据
        let tsVal = [],dlOne=[],dlTwo=[];
        if(dlVal.length>1){
            dlOne=dlVal[0].value;
            dlTwo=dlVal[1].value;
        }
        dlOne.map((item1,index) => {
            tsVal.push([item1,dlTwo[index],wdVal[index]]);
        })
        //x,y轴 自定义
        let xAxisCustom = params.axios.xAxios;
        let yAxisCustom = params.axios.yAxios.yAxios;

        //判断数据是否超过15条  grid专用
        let isDataLengthToNum = function () {
            let min = 15;
            if (!dataAll.dt) return false;
            if (dataAll.dt.length > min) {
                return true;
            } else {
                return false;
            }
        };
        let option = {
            tooltip: {
                formatter: function (data) {
                    if(wd[0]){
                        return wd[0].alias + '：' + data.value[2] + '<br>'
                        + dlVal[0].aliasNmae + '：' + data.value[0] + '<br>'
                        + dlVal[1].aliasNmae + '：' + data.value[1] 
                    }
                    return dlVal[0].aliasNmae + '：' + data.value[0] + '<br>'
                        + dlVal[1].aliasNmae + '：' + data.value[1] 

                },
            },
            grid: {
                top: comConfig.grid.top + '%',
                bottom: comConfig.grid.bottom + '%',
                left: comConfig.grid.left + '%',
                right: comConfig.grid.right + '%',
                containLabel: true
            },
            xAxis:  xAxisCustom,
            yAxis:  yAxisCustom,
            color: colorList,
            series: (() => {
                let list = [];
                let scatter=params.scatter;
                list.push({
                    type:this.type,
                    data: tsVal,
                    barMaxWidth: '30',
                    barGap: '30%',
                    symbol: scatter.symbol ,
                    symbolSize: scatter.symbolSize,
                    label: {
                        show: scatter.show || false,
                        position: 'top',    
                    },
                    itemStyle: {
                        color:scatter.color
                    },
                    large:scatter.large,
                    coordinateSystem: nowChart.name === '圆环图' ? 'polar' : 'cartesian2d',
                });
                return list;
            })()
        };
        echart.clear();
        echart.setOption(option);
        echart.resize();
    }
}
